// The video editor's shell strings (components/Editor), under t('editor.rve.shell.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  topBar: {
    unsavedChanges: 'Alterações não salvas',
    savesToAccountHint: 'As alterações são salvas na sua conta enquanto você trabalha',
    savesAutomatically: 'Salva automaticamente',
    justNow: 'agora mesmo',
    pendingHint: 'Não conseguimos acessar sua conta, então isto está salvo neste navegador; continuamos tentando.',
    deviceHint: 'Não conseguimos acessar sua conta quando isto abriu, então as alterações ficam neste navegador. Abra a página de novo para salvá-las na sua conta.',
    savedOnDevice: 'Salvo neste dispositivo {when}',
    savedToAccount: 'Salvo na sua conta',
    saved: 'Salvo',
    savedWhen: 'Salvo {when}',
    backToProject: 'Voltar ao projeto',
    projectName: 'Nome do projeto',
    rename: 'Renomear',
    undo: 'Desfazer',
    redo: 'Refazer',
    videoFormat: 'Formato do vídeo',
    format: 'Formato',
    keyboardShortcuts: 'Atalhos de teclado',
    watermarkHint: 'As exportações do plano grátis têm uma pequena marca d’água',
    removeWatermark: 'Remover marca d’água',
    exporting: 'Exportando {progress}%',
    export: 'Exportar',
  },
  formats: {
    vertical: { label: 'Vertical', hint: 'TikTok, Reels, Shorts' },
    square: { label: 'Quadrado', hint: 'Posts do feed' },
    portrait: { label: 'Retrato', hint: 'Instagram, Facebook' },
    landscape: { label: 'Paisagem', hint: 'YouTube, web' },
  },
  exportDialog: {
    title: 'Exportar vídeo',
    description: 'Um MP4 feito com tudo o que está na linha do tempo.',
    format: 'Formato',
    size: 'Tamanho',
    length: 'Duração',
    ready: 'Seu vídeo está pronto',
    download: 'Baixar',
    exportAgain: 'Exportar de novo',
    starting: 'Começando…',
    rendering: 'Processando',
    keepEditing: 'Você pode fechar isto e continuar editando: a exportação continua, e as alterações que você fizer agora não entram nela.',
    failed: 'A exportação falhou.',
    tryAgain: 'Tentar de novo',
    watermark: 'As exportações do plano grátis têm uma pequena marca d’água.',
    upgrade: 'Fazer upgrade',
    tooLong: 'As exportações podem ter até 15 minutos, e este vídeo tem {length}. Corte-o na linha do tempo ou na transcrição e depois exporte.',
    addSomethingFirst: 'Adicione algo à linha do tempo primeiro',
    exportVideo: 'Exportar vídeo',
    earlierExports: 'Exportações anteriores',
  },
  shortcuts: {
    title: 'Atalhos de teclado',
    description: 'Funcionam em qualquer lugar do editor, exceto enquanto você digita em um campo.',
    playPause: 'Reproduzir / pausar',
    frameStep: 'Voltar / avançar um quadro',
    secondStep: 'Voltar / avançar um segundo',
    jumpEnds: 'Ir para o início / o fim',
    split: 'Dividir a camada selecionada no cursor',
    delete: 'Excluir a camada selecionada',
    duplicate: 'Duplicar a camada selecionada',
    undo: 'Desfazer',
    redo: 'Refazer',
    saveNow: 'Salvar agora',
    export: 'Exportar',
    deselect: 'Desmarcar',
    showShortcuts: 'Mostrar atalhos',
  },
  inspector: {
    kinds: {
      text: 'Texto',
      video: 'Vídeo',
      image: 'Imagem',
      audio: 'Áudio',
      captions: 'Legendas',
      sticker: 'Figurinha',
      progressBar: 'Barra de progresso',
    },
    noSettings: 'Esta camada não tem configurações.',
    format: 'Formato',
    background: 'Fundo',
    backgroundColor: 'Fundo {color}',
    customColour: 'Cor personalizada',
    customBackground: 'Cor de fundo personalizada',
    backgroundHint: 'Aparece onde nenhuma camada cobre a tela.',
    safeZones: 'Zonas seguras',
    safeZonesHint: 'Sombreia onde o TikTok, o Reels e o Shorts colocam os botões e as legendas deles, para nada importante ficar embaixo.',
    showSafeZones: 'Mostrar zonas seguras',
    summaryOne: '1 camada · {length} de duração. Selecione uma camada na tela ou na linha do tempo para alterá-la.',
    summaryMany: '{n} camadas · {length} de duração. Selecione uma camada na tela ou na linha do tempo para alterá-la.',
    duplicateLayer: 'Duplicar camada',
    duplicate: 'Duplicar',
    deleteLayer: 'Excluir camada',
    delete: 'Excluir',
    thisVideo: 'Este vídeo',
    hideProperties: 'Ocultar propriedades',
    properties: 'Propriedades',
  },
  library: {
    nav: 'Biblioteca',
    hidePanel: 'Ocultar painel',
    transcript: { label: 'Transcrição', title: 'Transcrição' },
    captions: { label: 'Legendas', title: 'Legendas' },
    text: { label: 'Texto', title: 'Texto' },
    uploads: { label: 'Uploads', title: 'Seus uploads' },
    stock: { label: 'Banco', title: 'Vídeos de banco' },
    images: { label: 'Imagens', title: 'Imagens' },
    audio: { label: 'Áudio', title: 'Música e sons' },
    brand: { label: 'Marca', title: 'Kit de marca' },
    exports: { label: 'Exportados', title: 'Exportações' },
  },
  mobile: {
    nav: 'Editar',
    transcript: 'Transcrição',
    captions: 'Legendas',
    text: 'Texto',
    format: 'Formato',
    exports: 'Exportados',
  },
  brand: {
    logoUpdated: 'Logo atualizado',
    logoAdded: 'Logo adicionado',
    captionStyleSaved: 'Estilo de legenda salvo',
    captionsRestyled: 'Legendas com o novo estilo',
    logo: 'Logo',
    upload: 'Enviar',
    pngHint: "PNG, JPEG ou WebP de até 2 MB. Um PNG com fundo transparente fica melhor.",
    corner: 'Canto',
    corners: {
      topLeft: 'superior esquerdo',
      topRight: 'superior direito',
      bottomLeft: 'inferior esquerdo',
      bottomRight: 'inferior direito',
    },
    size: 'Tamanho',
    opacity: 'Opacidade',
    updateLogo: 'Atualizar o logo neste vídeo',
    addLogo: 'Adicionar o logo a este vídeo',
    captionStyle: 'Estilo de legenda',
    savedStyle: 'Salvo: legendas {font}.',
    customFont: 'personalizadas',
    styleHint: 'Deixe as legendas de um vídeo do jeito que você gosta, salve aqui e dê o mesmo visual a todos os vídeos.',
    saveCurrent: 'Salvar atual',
    applySaved: 'Aplicar salvo',
    accountHint: "Seu kit de marca é da sua conta: o mesmo logo e estilo de legendas aqui, no editor de clipes e em cada clipe que você exportar.",
    replace: "Trocar",
    remove: "Tirar o logo",
    failed: "Não deu para salvar. Tente de novo.",
    tooBig: "Essa imagem passa de 2 MB.",
    notPicture: "Essa não é uma imagem PNG, JPEG ou WebP.",
  },
  editor: {
    restored: 'Continuamos de onde você parou: suas edições feitas {ago}.',
    startOver: 'Recomeçar do original',
    dismiss: 'Fechar',
    opening: 'Abrindo seu projeto…',
    properties: 'Propriedades',
  },
  stage: {
    frameError: 'Não foi possível desenhar este quadro',
    layerFailed: 'Uma camada não carregou.',
    linkExpired: 'Um link de mídia pode ter expirado: abrir o projeto de novo busca links novos.',
    startWithVideo: 'Comece com um vídeo',
    startHint: 'Traga suas imagens e depois corte, legende e adicione texto na linha do tempo abaixo.',
    uploadVideo: 'Enviar um vídeo',
    browseStock: 'Ver vídeos de banco',
    addTitle: 'Adicionar um título',
    startHintPhone: 'Traga suas imagens e depois corte, legende e adicione texto pelas abas abaixo.',
  },
  timelineLabels: {
    text: 'Texto',
    image: 'Imagem',
    video: 'Vídeo',
    audio: 'Áudio',
    caption: 'Legenda',
    sticker: 'Figurinha',
    progressBar: 'Barra de progresso',
    shape: 'Forma',
    item: 'Item',
  },
  renders: {
    countOne: '1 exportação',
    countMany: '{n} exportações',
    none: 'Nenhuma exportação ainda',
    refresh: 'Atualizar',
    nothingYet: 'Nada exportado ainda',
    keptHere: 'O que você exporta do editor fica guardado aqui, pronto para baixar de novo.',
    exportThis: 'Exportar este vídeo',
    exporting: 'Exportando',
    video: 'Vídeo',
    failed: 'A exportação falhou',
    download: 'Baixar',
  },
  page: {
    opening: 'Abrindo seu projeto…',
    openFailed: 'Não foi possível abrir este projeto.',
    clipFailed: 'Não foi possível abrir este clipe',
    projectFailed: 'Não foi possível abrir este projeto',
    goBack: 'Voltar',
    seoTitle: 'Editor de vídeo - Ferramenta profissional de edição de vídeo online',
    seoDescription:
      'Edite seus vídeos com o nosso poderoso editor de vídeo online. Adicione legendas, camadas, animações e efeitos. Edição com linha do tempo e prévia em tempo real. Perfeito para criar conteúdo envolvente para as redes sociais.',
  },
};
